module.exports = __webpack_public_path__ + "static/media/uk.6f382b2d.png";